<div class="page py-4">
  <div id="legals" class="container pt-3">
    <div class="terms-container">
      <div class="row mb-4">
        <div class="col">
          <div class="content pt-4 pt-md-0">
            <h1>Aviso de Privacidad</h1>
            <hr class="separator" />
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col">
          <div class="content">
            <!-- #######  THIS IS A COMMENT - Visible only in the source editor #########-->
            <p>
              De conformidad con lo establecido en la Ley Federal de Protección
              de Datos Personales en Posesión de los Particulares (LFPDPPP), y
              demás normatividad secundaria vigente aplicable, así como
              estándares nacionales e internacionales en materia de protección
              de datos personales, con el propósito de garantizar la privacidad
              y el derecho a la autodeterminación informativa y protección de
              los Datos Personales, el Centro Ricardo B. Salinas Pliego pone a
              su disposición el siguiente aviso de privacidad:
            </p>
            <p>
              Centro Ricardo B. Salinas Pliego, es responsable del uso y
              protección de sus datos personales, en este sentido y atendiendo
              las obligaciones legales establecidas en la Ley Federal de
              Protección de Datos Personales en Posesión de los Particulares
              (LFPDPPP), a través de este instrumento se informa a los titulares
              de los datos, los datos que de ellos se recaba y los fines que se
              le darán a dicha información.
            </p>
            <p>
              Le informamos a usted que el Centro Ricardo B. Salinas Pliego,
              tiene su domicilio&nbsp;ubicado en:
            </p>
            <p>
              Camino a Santa Teresa #187 Col. Parques del Pedral, Ciudad de
              México C.P. 14000
            </p>
            <p>
              Los datos que se recopilarán en esta plataforma son: Nombre,
              Género, Edad, Correo electrónico y Ciudad donde labora el usuario
              de la plataforma. Es necesaria la recopilación de estos datos
              personales para llevar a cabo las actividades intrínsecas al
              objeto social y de operación de la Organización Centro Ricardo B.
              Salinas Pliego, por lo que tiene la obligación legal y social de
              cumplir con las medidas, legales y de seguridad suficientes para
              proteger aquellos datos personales que haya recabado para las
              finalidades que en la presente política de privacidad serán
              descritas.
            </p>
            <ul>
              <li>
                Mantener comunicación con los participantes de la organización e
                interesados en las actividades de su agenda de eventos.
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>Tus datos personales permitirán actividades como:</p>
            <ul>
              <li>
                Enviar información vía correo electrónico que pudieran llegar a
                ser de tu interés.
              </li>
              <li>
                Realizar inscripciones a diversas actividades de formación,
                divulgación del conocimiento, la cultura y las artes y dinámicas
                de colaboración en red.
              </li>
              <li>Uso de información con fines estadísticos internos.</li>
            </ul>
            <p>&nbsp;</p>
            <p>
              Le informamos que sus datos personales serán utilizados para los
              fines señalados.
            </p>
            <p>
              Usted tiene en todo momento el derecho a conocer qué datos
              personales tenemos de usted, para qué los utilizamos y las
              condiciones del uso que les damos (Acceso). Asimismo, es su
              derecho solicitar la corrección de su información personal en caso
              de que esté desactualizada, sea inexacta o incompleta
              (Rectificación); de igual manera, tiene derecho a que su
              información se elimine de nuestros registros o bases de datos
              cuando considere que la misma no está siendo utilizada
              adecuadamente (Cancelación); así como también a oponerse al uso de
              sus datos personales para fines específicos (Oposición). Estos
              derechos se conocen como derechos ARCO.
            </p>
            <p>
              Para el ejercicio de cualquiera de los derechos ARCO, se deberá
              presentar la solicitud y remitirla al correo electrónico:
              <a href="mailto:info@centroricardobsalinaspliego.org"
                >info@centroricardobsalinaspliego.org</a
              >
            </p>
            <p>
              La solicitud de ejercicio de estos derechos debe contener la
              siguiente información:
            </p>
            <p>
              De acuerdo con el artículo 29 de la Ley Federal de Protección de
              Datos Personales en Posesión de los Particulares la solicitud de
              acceso, ratificación, cancelación u oposición (ARCO) debe contener
              y acompañar:
            </p>
            <ol>
              <li>
                El nombre del titular de la información y domicilio u otro medio
                para comunicarle la respuesta a su solicitud.
              </li>
              <li>
                Copia de documento que acredite su identidad (credencial INE o
                pasaporte).
              </li>
              <li>
                Descripción clara y precisa de los datos personales respecto de
                los que busca ejercer alguno de los derechos ARCO.
              </li>
              <li>
                Información, documento o elemento que facilite la localización
                de los datos personales.
              </li>
            </ol>
            <p>&nbsp;</p>
            <p>
              La respuesta a la solicitud se dará en un plazo máximo de 20 días
              hábiles contados desde la fecha en que se recibió la solicitud tal
              y como lo marca el artículo 32 de la Ley Federal de Protección de
              Datos Personales en Posesión de Particulares y se comunicará de la
              siguiente manera:
            </p>
            <p>
              Camino a Santa Teresa #187 Col. Parques del Pedral, Ciudad de
              México C.P. 14000
            </p>
            <p>
              Los datos de contacto de la persona o departamento de datos
              personales, que está a cargo de dar trámite a las solicitudes de
              derechos ARCO, son los siguientes:
            </p>
            <ol>
              <li>
                Domicilio: Camino a Santa Teresa #187 Col. Parques del Pedral,
                Ciudad de México C.P. 14000
              </li>
              <li>Teléfono: 01 (55) 1720-7000 Ext. 74975</li>
              <li>
                Correo electrónico:
                <a href="mailto:info@centroricardobsalinaspliego.org"
                  >info@centroricardobsalinaspliego.org</a
                >
              </li>
            </ol>
            <p>&nbsp;</p>
            <p>
              En cualquier momento usted puede revocar su consentimiento para el
              uso de sus datos personales. Asimismo, usted deberá considerar que
              la revocación de su consentimiento implicará que no podamos seguir
              compartiendo con usted información referente a las actividades que
              realiza www.centroricardobsalinaspliego.org
            </p>
            <p>
              Del mismo modo, podrá solicitar la información para conocer el
              procedimiento y requisitos para la revocación del consentimiento,
              así como limitar el uso y divulgación de su información personal.
              Estas solicitudes deberán contener la siguiente información:
            </p>
            <ul>
              <li>Nombre</li>
              <li>Teléfono</li>
              <li>Correo Electrónico</li>
              <li>
                Motivo de la solicitud para dar de baja sus datos en nuestra
                base de datos
              </li>
              <li>Firma</li>
            </ul>
            <p>&nbsp;</p>
            <p>
              La respuesta a la solicitud de revocación o limitación de
              divulgación de sus datos se dará a más tardar en 20 días hábiles
              contados a partir de que ingresa la solicitud y se comunicará a
              través del correo electrónico en el que proporcionó la solicitud
              de Derechos ARCO.
            </p>
            <p>
              En el correo electrónico en el que deberá adjuntar su solicitud:
            </p>
            <p>info@centroricardobsalinaspliego.org</p>
            <p>
              El presente aviso de privacidad puede sufrir modificaciones,
              cambios o actualizaciones derivadas de nuevos requerimientos
              legales; de las necesidades en el tratamiento de datos personales
              o por otras causas, por lo cual, nos comprometemos a mantenerlo
              informado sobre los cambios que pueda sufrir el presente aviso de
              privacidad, sin embargo, usted puede solicitar información sobre
              si el mismo ha sufrido algún cambio en el siguiente correo
              electrónico:
            </p>
            <p>info@centroricardobsalinaspliego.org</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
